var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 13 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#0077C8",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.354 13.31c3.038 0 5.5-2.462 5.5-5.5 0-3.037-2.462-5.5-5.5-5.5-3.037 0-5.5 2.463-5.5 5.5",
    transform: "translate(-496.000000, -607.000000) translate(120.000000, 548.000000) translate(212.000000, 51.000000) translate(163.707220, 8.000000) translate(7.354409, 8.372986) scale(-1, 1) translate(-7.354409, -8.372986) translate(0.000000, 0.790358) translate(7.354409, 7.810848) rotate(64.000000) translate(-7.354409, -7.810848)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M6.868 4.995L3.457 3.451 5.575 0",
    transform: "translate(-496.000000, -607.000000) translate(120.000000, 548.000000) translate(212.000000, 51.000000) translate(163.707220, 8.000000) translate(7.354409, 8.372986) scale(-1, 1) translate(-7.354409, -8.372986) translate(0.000000, 0.790358)"
  }))))))));
};
export default SvgRefresh;